import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { featureFlagReducer } from '@surfline/web-common/dist/features';
import status from './status';
import cms from './cms';
import user from './user';
import map from './map';
import tides from './tides';
import forecast from './forecast';
import solunar from './solunar';
import whatsNewModal from './whatsNewModal';

export default combineReducers({
  routing: routerReducer,
  status,
  forecast,
  tides,
  cms,
  user,
  map,
  solunar,
  whatsNewModal,
  flags: featureFlagReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js